(function($) {
	$(document).ready(function() {
 		$('form#jobs-search-form').on( 'submit', function( ev ) {
			ev.preventDefault();
			jobsForm();
		});

		$('#all_jobs').on('click', function(ev) {
			ev.preventDefault();
			$(this).fadeOut();
			jobsForm('-1');
		});

		$(document).on( 'submit', '.page-jobs form#search-fails', function( ev ) {
			ev.preventDefault();
			jobsForm();
		});

 		function jobsForm(viewAll) {



 			var jobType = $("#positionType option:selected").val();
 			var jobCategory = $("#positionCategory option:selected").val();
 			var jobSearch = $('#positionSearch').val();
 			var jobNumber = 6;

 			var jobCategoryPage = $('main.taxonomy-jobs').data('category');
 			var jobTagsPage = $('main.taxonomy-jobs').data('tags');

 			var jobSearchFail = $('.page-jobs form#search-fails #failSearch').val();

 			if((jobSearchFail != undefined) && (jobSearchFail.length > 0)) {
 				jobSearch = jobSearchFail;
 				jobType = '';
 				jobCategory = '';
 			}

 			if(viewAll != undefined) {
 				jobNumber = parseInt(viewAll);
 			}
 

			$.ajax({
				url: jobs_search.ajaxurl,
				type: 'post',
				data: {
					action: 'jobs_search',
					jobType : jobType,
					jobCategory : jobCategory,
					jobSearch : jobSearch,
					jobNumber : jobNumber,
					jobCategoryPage : jobCategoryPage,
					jobTagsPage : jobTagsPage,

				},
				beforeSend: function() {
					$('.jobs-container .loop-jobs').remove();
					$('#taxonomy-header').remove();
					$('h5.no-tags').remove();
					$('#search-fails').remove();
					if((jobCategory.length == 0) && (jobType.length  == 0) && (jobSearch.length  == 0) && (jobNumber == 6)) {
						$('.jobs-header-title').animate({'opacity': 1} , 300);
						$('#single-job-main').slideDown();
						$('.related-jobs h2').slideDown();
						$('.related-jobs').animate({'padding-top' : '90px'}, 300);
					} else {
						$('.jobs-header-title').animate({'opacity': 0} , 300);

						$('#single-job-main').slideUp();
						$('.related-jobs').animate({'padding-top' : '50px'}, 300);
						$('.related-jobs h2').slideUp();
			
					}


				},
				success: function( result ) {
					
					$('.jobs-container').append(result);
				
					/* MAKES ALL JOBS THE SAME HEIGHT */
					var loop_jobs_titles = document.querySelectorAll('.loop-jobs .loop-jobs-container .loop-jobs-container-inner');
					if(loop_jobs_titles.length > 0) {
						sameHeight(loop_jobs_titles, 768);
					}

					/* CHECKS WHETHER A 'VIEW ALL' BUTTON#all_jobs IS NEEDED */
					var jobsAll = document.querySelectorAll('.loop-jobs');
					if((jobNumber > 0) && (jobsAll.length >= 6)) {
						$('#all_jobs').fadeIn();
					} else if((jobNumber > 0) && (jobsAll.length < 6)) {
						$('#all_jobs').fadeOut();
					}

					
					var jobs_top = $('.search-jobs-form').offset().top + $('.search-jobs-form').outerHeight();

					$('html, body').animate({
				        scrollTop: jobs_top,
				    }, 1000);

				}
			})
 		}

	});  
})(jQuery);